export default class Channels {
	public static readonly web: string = "web";
	public static readonly bot: string = "bot";
	public static readonly bookings: string = "bookings";
}